export default {
    address: {
        currentResidentialAddress: {
            addressLine1: '',
            addressLine2: '',
            addressLine3: '',
            provinceCode: '',
            cityCode: '',
            districtCode: '',
            postalCode: '',
            addressCountry: '',
        },
        correspondenceAddress: {},
        correspondenceAddressDifferent: '',
        cartAddress: '',
        atmCountry: '',
        selectReasonsForOpeningAccount: '',
        otherReasonForOpeningAccountInAnotherCountryText: ''
    },
}
